// @flow
import { reduxForm } from 'redux-form'
import { compose, withProps } from 'recompose'
import { updateCharity } from './actions'
import {
  withInitialValuesAndStripe,
  validate
} from '../mycharity/charity/EditCharityLegalForm'
import withAutoFocusOnError from './withAutofocusOnError'
import CharityLegalForm from '../../ui/forms/charity-legal-form'
import withTranslations from '../../core/withTranslations'

const withReduxForm = reduxForm({
  form: 'register-charity-legal',
  validate,
  onSubmit(values, dispatch, props) {
    props.onNext()
    return dispatch(updateCharity({ ...values, published: true }))
  }
})

const withHandlers = withProps(props => {
  return {
    handleCancel(e) {
      props.onBack(e)
    }
  }
})

const fieldList = [
  'ownerName',
  'ownerSurname',
  'ownerEmail',
  'ownerPhone',
  'ownerBirthdate',
  'ownerAddress',
  'legalName',
  'tin',
  'legalAddress'
]

export const translations = withTranslations({
  ownerContactDetailText: 'charity.legalForm.ownerContactDetail',
  ownerContactDetailHelperText: 'charity.legalForm.ownerContactDetailHelper',
  ownerContactDetailHelper2Text: 'charity.legalForm.ownerContactDetailHelper2',
  firstNameLabel: 'forms.field.firstName.label',
  lastNameLabel: 'forms.field.lastName.label',
  emailLabel: 'forms.field.email.label',
  phoneLabel: 'forms.field.phone.label',
  birthdateLabel: 'forms.field.birthdate.label',
  addressLabel: 'forms.field.address.label',
  charityDetailsText: 'charity.legalForm.charityDetails',
  legalNameLabel: 'charity.legalForm.legalNameLabel',
  tinLabel: 'charity.legalForm.tinLabel',
  legalAddressLabel: 'charity.legalForm.legalAddressLabel',
  stripeAccountLabel: 'charity.legalForm.stripeAccountLabel',
  stripeAccountHelperText: 'charity.legalForm.stripeAccountHelper',
  errorNotificationText: 'forms.validation.errorNotification'
})

export const decorator = compose(
  withInitialValuesAndStripe,
  withAutoFocusOnError(fieldList),
  withReduxForm,
  withProps({
    showStripeSection: false
  }),
  withHandlers,
  translations
)

export default decorator(CharityLegalForm)



// WEBPACK FOOTER //
// ./src/services/register-charity/Legal.js